import api from "./api";

export async function sync() {
  const res = await api.post('/onedrive/sync')
  return res.data
}
